var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEstadoCargado(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    height: 19.5,
    className: "svg-primary",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19,0H5C2.24,0,0,2.24,0,5v19h24V5c0-2.76-2.24-5-5-5Zm-8.01,9.17l-1.11,1.11c-.39.39-1.03.39-1.43,0-.2-.2-.3-.45-.3-.71,0-.26.1-.52.3-.71l2.59-2.59c.25-.25.58-.39.93-.39s.68.14.93.39l2.62,2.62c.39.39.39,1.03,0,1.43-.39.39-1.03.39-1.43,0l-1.11-1.11v7.92c0,.56-.45,1.01-1.01,1.01s-1.01-.45-1.01-1.01v-7.95Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEstadoCargado);
export default __webpack_public_path__ + "static/media/icon_estado_cargado.20679ddd.svg";
export { ForwardRef as ReactComponent };